// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3UCyv","title":"InfoRow_title__hCPcD"};